import { render } from "./RequiredForm.vue?vue&type=template&id=a9696988"
import script from "./RequiredForm.vue?vue&type=script&lang=js"
export * from "./RequiredForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__